import { Rating } from "@mui/material";
import { useEffect, useState } from 'react';
import { useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import avatar from '../../constants/images/avatar.svg';
import { resolveMediaUrl } from "../../configs/urls";
import { MAIN_ROUTES } from "../../routing/main_routes";
import BadgeTopCleaner from "../BadgeTopCleaner/BadgeTopCleaner";
import styles from './CleanerBioShort.module.scss';

const CleanerBioShort = ({ application }) => {
  const { application_price, application_message, created_by_user } = application;
  const { first_name, last_name, cleaner_total_rating, is_top_cleaner } = created_by_user;
  const [deviceWidth, setDeviceWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setDeviceWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const navigate = useNavigate();

  const { order } = useSelector(state => state.cleaningRequests);

  const handleCreateOrder = async () => {
    navigate(MAIN_ROUTES.PAYMENT, { state: { cleaning_request: order, application } });
  }

  if (deviceWidth > 768) {
    return (
      <div className={styles.cleanerBioShort_wrapper}>
        <div style={{alignItems: "flex-start"}} className={styles.cleanerBioShort_wrapper_fullName}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <img
              className={`${styles.cleanerBioShort_wrapper_fullName_photo} ${is_top_cleaner ? styles.topCleaner : ''}`}
              src={resolveMediaUrl(created_by_user?.photos[0]) || avatar} alt="user`s profile photo" />
            <div className={styles.cleanerBioShort_wrapper_fullName_badge}>{is_top_cleaner &&
              <BadgeTopCleaner />}</div>
          </div>

          <div style={{flex: 1, display: "flex", flexDirection: "column", gap: 12}}>
            <div className={styles.cleanerBioShort_wrapper_fullName_titleContainer}>
              <h3 className={styles.fullName}>{first_name} {last_name}</h3>
              <div className={styles.cleanerBioShort_wrapper_fullName_titleContainer_badge}>
                {is_top_cleaner && <BadgeTopCleaner />}
              </div>
              <button
                onClick={handleCreateOrder}
                className={`${styles.cleanerBioShort_wrapper_info_button} ${styles.laptop}`}
              >Обрати
              </button>
            </div>
            <div style={{padding: 0}} className={styles.cleanerBioShort_wrapper_info}>
              <div className={styles.cleanerBioShort_wrapper_info_detailed}>
                <div className={styles.cleanerBioShort_wrapper_info_detailed_price}>
                  <p>₴ {+application_price}</p>
                  <p>Ціна клінера</p>
                </div>

                <div className={styles.cleanerBioShort_wrapper_info_detailed_rating}>
                  <Rating
                    style={{ fontSize: '24px' }}
                    size="large"
                    name="read-only"
                    value={cleaner_total_rating}
                    readOnly
                  />
                  <p>Рейтинг</p>
                </div>
              </div>

              <div className={styles.cleanerBioShort_wrapper_info_bio}>
                <p style={{ fontWeight: 700 }}>Повідомлення від Клінера</p>
                <p>{application_message}</p>
              </div>

              <button
                onClick={handleCreateOrder}
                className={`${styles.cleanerBioShort_wrapper_info_button} ${styles.mobile}`}
              >Обрати
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.cleanerBioShort_wrapper}>
      <div className={styles.cleanerBioShort_wrapper_fullName}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <img
            className={`${styles.cleanerBioShort_wrapper_fullName_photo} ${is_top_cleaner ? styles.topCleaner : ''}`}
            src={resolveMediaUrl(created_by_user?.photos[0]) || avatar} alt="user`s profile photo" />
          <div className={styles.cleanerBioShort_wrapper_fullName_badge}>{is_top_cleaner &&
            <BadgeTopCleaner />}</div>
        </div>

        <div className={styles.cleanerBioShort_wrapper_fullName_titleContainer}>
          <h3 className={styles.fullName}>{first_name} {last_name}</h3>
          <div className={styles.cleanerBioShort_wrapper_fullName_titleContainer_badge}>
            {is_top_cleaner && <BadgeTopCleaner />}
          </div>
          <button
            onClick={handleCreateOrder}
            className={`${styles.cleanerBioShort_wrapper_info_button} ${styles.laptop}`}
          >Обрати
          </button>
        </div>
      </div>

      <div className={styles.cleanerBioShort_wrapper_info}>
        <div className={styles.cleanerBioShort_wrapper_info_detailed}>
          <div className={styles.cleanerBioShort_wrapper_info_detailed_price}>
            <p>₴ {+application_price}</p>
            <p>Ціна клінера</p>
          </div>

          <div className={styles.cleanerBioShort_wrapper_info_detailed_rating}>
            <Rating
              style={{ fontSize: '24px' }}
              size="large"
              name="read-only"
              value={cleaner_total_rating}
              readOnly
            />
            <p>Рейтинг</p>
          </div>
        </div>

        <div className={styles.cleanerBioShort_wrapper_info_bio}>
          <p style={{ fontWeight: 700 }}>Повідомлення від Клінера</p>
          <p>{application_message}</p>
        </div>

        <button
          onClick={handleCreateOrder}
          className={`${styles.cleanerBioShort_wrapper_info_button} ${styles.mobile}`}
        >Обрати
        </button>
      </div>
    </div>
  );
};

export default CleanerBioShort;
